import React from 'react';
import { ProgressBar, OverlayTrigger, Tooltip } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';

export default ({ deal, onClick, type }) => {
  if (deal && deal.agreement_info) {
    const progress = deal.progress ? deal.progress : 0;

    if (type === 'dashboard') {
      return (
        <div className="dash-agreement" onClick={onClick}>
          <div className="title">{deal.agreement_info.name}</div>
        </div>
      );
    } else {
      return (
        <div className="deal" onClick={onClick}>
          <OverlayTrigger
            overlay={
              <Tooltip id="tooltip-split">{deal.agreement_info.name}</Tooltip>
            }
            placement="top"
          >
            <div className="agreement">{deal.agreement_info.name}</div>
          </OverlayTrigger>
          <div className="work-view">
            {deal.work_info && (
              <div className="team">{deal.work_info.name}</div>
            )}
            {deal.work_info && (
              <FontAwesome className="dot-icon" name="circle" />
            )}
            <div className="team">{deal.team_info && deal.team_info.name}</div>
          </div>
          <ProgressBar
            now={progress}
            bsStyle={progress === 100 ? 'success' : 'info'}
            label={`${progress}% Complete`}
          />
        </div>
      );
    }
  } else {
    return null;
  }
};



// WEBPACK FOOTER //
// src/components/Deals/Deal.jsx